<template>
  <div class="photos">
    <p class="pic-title">{{ title }}({{ limit }}张)：<span class="imp" v-if="required">*</span></p>

    <div class="photoList van-clearfix">
      <div
          class="imgBox"
          v-for="(item, index) in imgUpList"
          :key="'imgBox_'+index"
      >
        <div
            class="img"
            @click="showImagePreview(index)"
            :style="{'background-image': 'url(' + item.src + ')','background-repeat':'no-repeat','background-size':'cover', 'background-position':'center'}"
        ></div>
        <div class="deleted"
             @click="deletePhoto(index)">×
        </div>
      </div>
      <div class="takePhoto" v-if="isShowAdd" @click="takePhoto('imgUpList')">
        <p class="iconfont icon-camera"></p>
      </div>
    </div>
  </div>
</template>

<script>

import {ImagePreview} from "vant";

export default {
  props: {
    limit: {
      type: Number,
      default() {
        return 1
      }
    },
    required: {
      type: Boolean,
      default() {
        return false
      }
    },
    index: {
      type: Number,
      default() {
        return 0
      }
    },
    title: {
      type: String,
      default() {
        return ''
      }
    },
    showList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      imgUpList: [],
      isShowAdd: true
    }
  },
  components: {},
  mounted() {
    this.isShowAdd = this.showList.length < this.limit;
    this.imgUpList = this.showList || [];
  },
  watch: {
    showList(newList) {
      this.imgUpList = newList;
      this.isShowAdd = newList.length < this.limit;
    }
  },
  methods: {
    showImagePreview(index) {
      let images = this.imgUpList.map(m => {
        return m.src
      }) || [];
      ImagePreview({
        images,
        startPosition: typeof index === 'number' ? index : 0
      });
    },
    deletePhoto(index) {
      this.$emit('deletePicList', index, this.index);
      // this.imgUpList.splice(index, 1);
    },
    takePhoto() {
      // 原生拍照回调
      let _this = this;
      window.getPhotos = function (src) {
        if (src) {
          let list = src.split(';');
          // list.forEach((v, k) => {
          //   if (k < _this.limit) { // 限制张数
          //     _this.imgUpList.push({src: v});
          //   }
          // });
          let imgList = [];
          list.forEach((v, k) => {
            if (k < _this.limit) { // 限制张数
              imgList.push({src: v});
            }
          });
          _this.imgUpList = imgList;
          _this.$emit('uploadPicList', imgList, _this.index);
        } else {
          _this.$alertErr('上传失败！');
        }
      };
      let u = navigator.userAgent
      if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        /* eslint-disable no-undef */
        window.webkit.messageHandlers.toaddPhoto.postMessage(null);
      } else if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) {
        /* eslint-disable no-undef */
        method && method.choosePic();
      }
    },
  }
}
</script>
<style lang="stylus" scoped>
</style>
